import { useNavigate } from "react-router-dom";
import TopBar from "@/components/TopBar";
import { useOutfitDraft } from "@/context/OutfitDraftContext";

const QUICK = [100, 200, 350, 500, 1000];

export default function BudgetScreen() {
  const navigate = useNavigate();
  const { draft, update } = useOutfitDraft();

  const canContinue = !!(parseFloat(draft.budget) > 0);

  return (
    <div className="screen fade-in" data-testid="budget-screen">
      <TopBar title="BUDGET" />
      <div style={{ marginBottom: 22 }}>
        <div className="eyebrow" style={{ marginBottom: 10 }}>SET A CAP</div>
        <h2 className="h1" style={{ fontSize: 34 }}>
          What&apos;s your <em className="serif" style={{ fontStyle: "italic", fontWeight: 300 }}>budget</em>?
        </h2>
        <p className="body" style={{ marginTop: 12 }}>
          We&apos;ll keep the total outfit under this number.
        </p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 16, flex: 1 }}>
        <div className="field">
          <label className="label" htmlFor="b">Max budget (USD)</label>
          <input
            id="b"
            type="number"
            min="0"
            className="input"
            placeholder="200"
            value={draft.budget}
            onChange={(e) => update({ budget: e.target.value })}
            data-testid="budget-amount-input"
          />
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {QUICK.map((q) => (
            <button
              key={q}
              className={`chip ${String(draft.budget) === String(q) ? "active" : ""}`}
              onClick={() => update({ budget: String(q) })}
              data-testid={`budget-quick-${q}`}
            >
              ${q}
            </button>
          ))}
        </div>
      </div>

      <div style={{ marginTop: 16 }}>
        <button
          className="btn btn-primary"
          disabled={!canContinue}
          onClick={() => navigate("/style-pick")}
          data-testid="budget-continue-btn"
        >
          Continue
        </button>
      </div>
    </div>
  );
}
